<template>

    <div class="my-6">

        <div class="my-3">
            <ListBoxSelectWithImage :options="typeGasketMaterial" v-model="form.typeGasketMaterial"
                placeholder="Select Option" labelMain="Material Type" class="my-3" requires="True" />

            <div v-if="form.typeGasketMaterial == 'Other'">
                <BaseTextArea
                    label="Please tell us about the material you require. We can source material as a non-stock request, for additional leadtime and cost. "
                    v-model="form.typeGasketMaterialOther"
                    tooltip="We can source different material as a non-stock request, for additional leadtime and cost." />
            </div>

            <p class="p-3 text-xs bg-gray-50 shadow rounded text-blue-400">
                <span class="font-bold text-gray-500 italic">Currently Selected: </span>
                <span class="">{{ form.typeGasketMaterial }}</span>
            </p>

            





            <Alert
                message='We can source different gasket material as a non - stock request, for additional leadtime and cost.'
                class="my-3" />






        </div>

    </div>

</template>

<script setup>
import { inject } from 'vue';

import {
    typeGasketMaterial
} from '../../constants/Gasket';

import Alert from '../formComponents/Alert.vue';
import BaseTextArea from '../formComponents/BaseTextArea.vue';


import ListBoxSelectWithImage from '../formComponents/ListBoxSelectWithImage.vue';


const form = inject('form');

</script>